import { z } from "zod";

const scbSettingsZodObject = z.object({
    _id: z.literal("scb_mapping_settings"),
    _type: z.literal("SCB_MAPPING_SETTINGS"),

    mappings: z.record(
        z.string(), //accommodationType or accommodationSubType
        z.object({
            scbCode: z.string(),
            scbName: z.string(),
        }),
    ),
});

//1=husvagn; 2=husbil; 3=tält;4=stuga/villavagn/glampingtält; 5=övrigt boend

type ScbMappingSettings = z.infer<typeof scbSettingsZodObject>;

export { scbSettingsZodObject };
export type { ScbMappingSettings };
